import React, { FC, useState, useEffect, ReactNode } from 'react';
import './styles.scss';
import { Input } from '@cokitchen/cokitchen-components';
import { numberWithCommas } from 'utils/functions';
import { useLocation } from 'react-router-dom';

type Props = {
  data: any;
  className?: string;
  onChange?: () => void;
  actions?: ReactNode;
  showCheckbox?: boolean;
  selectedItems: any[];
  checked?: boolean;
};

const AddonCategoryCard: FC<Props> = ({
  checked,
  data,
  className,
  onChange,
  actions,
  showCheckbox,
  selectedItems
}) => {
  const [cardHovered, setCardHovered] = useState(false);
  const { pathname } = useLocation();
  const isSearch = () => {
    return pathname.includes('search');
  };

  useEffect(() => {
    if (isSearch()) {
      setCardHovered(true);
    }
  }, [pathname]);

  const toggleCardHovered = () => {
    if (!isSearch()) {
      setCardHovered(!cardHovered);
    }
  };
  return (
    <div
      onMouseEnter={toggleCardHovered}
      onMouseLeave={toggleCardHovered}
      className={`meal-category-card relative py-[14px] px-[20px] rounded border border-[#FAFAFA] ${className}`}>
      <div className='flex justify-between h-4 '>
        {showCheckbox && (
          <Input
            type='checkbox'
            name='new'
            checked={checked}
            checkColor='gray'
            onChange={onChange}
            className=' absolute right-4'
          />
        )}
        {selectedItems.length === 0 && actions}
      </div>

      <div>
        <div className=''>
          <div>
            <div className='flex justify-between items-center'>
              <div className='flex justify-center items-center bg-[#FEEBEE] rounded-full w-fit py-1 px-[8px] mb-[6px] mt-[8px]'>
                <p className='text-[10px] text-[#E60A2B] '>{data?.meal_addon_category?.name}</p>
              </div>
              <p className='text-[#595959] text-[11px] font-[400] mt-2'>
                {data?.parent_meal_data?.name}
              </p>
            </div>
            <div className='flex justify-between '>
              <div className='text-[12px]'>
                <p className='leading-[22px] text-sm font-medium'>
                  {data?.name || data.meal_data?.name}
                </p>
                <p className='pb-[20px] text-[#858585] text-xs leading-[22px]'>
                  N{numberWithCommas(data?.amount || data.meal_data?.amount)}
                </p>
              </div>
              <div className='w-[28px] h-[28px] mt-2 rounded-full'>
                <img
                  src={data?.brandLogo || data?.meal_data?.brand?.logo}
                  alt='Brand Logo'
                  className='object-cover w-full h-full'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddonCategoryCard;
